/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Mathematics16Inputs */

const en__field_enum_icsrm_mathematics16 = /** @type {(inputs: _Field_Enum_Icsrm_Mathematics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural Sciences & Mathematics`)
};

const de__field_enum_icsrm_mathematics16 = /** @type {(inputs: _Field_Enum_Icsrm_Mathematics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturwissenschaften & Mathematik`)
};

/**
* | output |
* | --- |
* | "Natural Sciences & Mathematics" |
*
* @param {_Field_Enum_Icsrm_Mathematics16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_mathematics16 = /** @type {((inputs?: _Field_Enum_Icsrm_Mathematics16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Mathematics16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_mathematics16(inputs)
	return de__field_enum_icsrm_mathematics16(inputs)
});
export { _field_enum_icsrm_mathematics16 as "_field_enum_ICSRM_MATHEMATICS" }